<mat-checkbox
  color="primary"
  *ngIf="displayAs !== 'toggle'; else toggle"
  [formControl]="formControlElement">
  {{ label }}
</mat-checkbox>
<ng-template #toggle>
  <mat-slide-toggle [formControl]="formControlElement">{{ label }}
  </mat-slide-toggle>
</ng-template>
